import { Block } from 'ui-kit/blocks'
import { Heading } from 'ui-kit/typography'
import { BuilderDocumentation } from '../Documentation'
import { BuilderAdvantages } from '../Advantages'
import classes from './BuilderFeatureSet.module.scss'

export const BuilderFeatureSet = () => {
  return (
    <Block
      variant={'shadowMob'}
      as={'section'}
      pad={'content'}
      className={classes.section}
    >
      <Heading size={'xxl'} as={'h2'} center balance className={classes.title}>
        Breakthrough feature set
      </Heading>
      <BuilderDocumentation />
      <BuilderAdvantages />
    </Block>
  )
}
